import { DPContainer } from "../message/Avatar";
const UserIcon = ({ color = "#0AB", ...props }) => (
    <DPContainer>
        <div
            style={{
                width: "42px",
                height: "42px",
                boxSizing: "border-box",
                borderRadius: "50%",
                objectFit: "cover",
                objectPosition: "bottom center",
                border: "2px solid "+color,
                alignContent: 'center',
                position: 'absolute',
                top: '0px'
            }} 
        >
            <svg 
                height={18}
                width={18} 
                style={{ display: "block", margin: "auto" }}
                version="1.1" 
                id="Capa_1" 
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 60.671 60.671"
            >
                <g>
                    <g>
                        <ellipse fill={color} cx="30.336" cy="12.097" rx="11.997" ry="12.097" />
                        <path fill={color} d="M35.64,30.079H25.031c-7.021,0-12.714,5.739-12.714,12.821v17.771h36.037V42.9
                C48.354,35.818,42.661,30.079,35.64,30.079z"/>
                    </g>
                </g>
            </svg>
        </div>
    </DPContainer>
);
export default UserIcon;